import defaultLogo from '@/assets/logo.png'
import egaLogoLight from '@/assets/metlanx_ega.png'
import egaLogoDark from '@/assets/mtx-ega-logo-darkmode.png'

const EGA_USERNAMES = new Set(['abdulla', 'teammetalnx'])

export function isAbdullaUser(name) {
  if (name == null) return false
  return EGA_USERNAMES.has(String(name).trim().toLowerCase())
}

/**
 * @param {string} name
 * @param {{ dark?: boolean, context?: 'sidebar' | 'report' | 'pdf' }} [options]
 */
export function platformLogoForUser(name, { dark = false, context = 'sidebar' } = {}) {
  if (!isAbdullaUser(name)) return defaultLogo
  // Report page + PDF always use the dark-mode EGA mark
  if (context === 'report' || context === 'pdf') return egaLogoDark
  // Sidebar: light mark in light theme, dark mark in dark theme
  return dark ? egaLogoDark : egaLogoLight
}

export function platformLogoClassForUser(name, { context = 'sidebar' } = {}) {
  if (isAbdullaUser(name)) {
    return context === 'report'
      ? 'predix-public-report__logo predix-public-report__logo--ega'
      : 'us-sidebar-logo us-sidebar-logo--ega'
  }
  return context === 'report'
    ? 'predix-public-report__logo'
    : 'us-sidebar-logo'
}
